var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footers"},[_c('div',[_c('P',{staticClass:"footer_tel"},[_vm._v("服务热线：4009883333")]),_c('P',{staticClass:"footer_info"},[_vm._v("Copyright ©2016 深圳市恒大饮品有限公司,All Rights Reserved")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }